if (!customElements.get('nosto-bundle-upsell-item')) {
  customElements.define(
    'nosto-bundle-upsell-item',
    // eslint-disable-next-line no-undef
    class NostoBundleUpsellItem extends window.BAO.CustomElement() {
      requiredEls = ['colorSelector']

      connectedCallback () {
        super.connectedCallback()
      }

      setupListeners () {
        if (this.els.colorSelect) {
          this.els.colorSelect.element.addEventListener(
            'change',
            this.handleColorChange.bind(this),
          )
        }

        if (this.els.variantSelector) {
          if (this.els.variantSelector.elements.length > 1) {
            this.productJSON = JSON.parse(
              this.els.productJSON.element.textContent,
            )

            this.els.variantSelector.elements.forEach(selector => {
              selector.addEventListener('change', this.variantChange.bind(this))
            })
          }
        }
      }

      async handleColorChange (event) {
        const selectedProductHandle = event.currentTarget.value
        try {
          const html = await this.fetchSectionHTML(selectedProductHandle)
          this.replaceWith(html.children[0])
        } catch (error) {
          console.error('fetchSectionHTML did not return HTML')
        }
      }

      async fetchSectionHTML (handle) {
        return await fetch(`/products/${handle}?section_id=${this.sectionId}`)
          .then(response => response.text())
          .then(responseText => {
            const innerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('#shopify-section-async-bundle-item')

            return innerHTML
          })
      }

      variantChange () {
        const selectedVariants = Array.from(
          this.els.variantSelector.elements,
        ).map(select => select.value)

        const matchedVariant = this.productJSON.find(variant => {
          return selectedVariants.every(
            (option, index) => variant.options[index] === option,
          )
        })

        this.updateATC(matchedVariant.available)
      }

      updateATC (available) {
        if (available) {
          this.els.atcButton.element.style.display = 'block'
          this.els.bisButton.element.style.display = 'none'
        } else {
          this.els.atcButton.element.style.display = 'none'
          this.els.bisButton.element.style.display = 'block'
        }
      }

      get sectionId () {
        return 'async-bundle-item'
      }
    },
  )
}
